<footer class="footer">
  <div class="row align-items-center justify-content-xl-between">
    <div class="col-xl-6">
      <div class="copyright text-center text-xl-left text-muted">
        &copy; {{ test | date: "yyyy" }} <a href="http://www.brsis.com.br" class="font-weight-bold ml-1" target="_blank">BRSIS</a>
      </div>
    </div>
    <div class="col-xl-6">
    </div>
  </div>
</footer>
